import Dashboard2 from 'views/Admin/Dashboard/index.tsx';
import { DashboardType } from 'views/Admin/Dashboard/types';
import Qualys from 'views/Admin/Qualys.jsx';
import { getReleaseNotesLabel } from 'views/Admin/ReleaseNotes/helper.js';
import CompanyConfiguration from 'views/Company/Configuration/';
import { CompanyList } from 'views/Company/List.jsx';
import CVESubscription from 'views/CVE/Subscription';
import Findings from 'views/Findings/';
import { SourceType, sourceTypeConfig } from 'views/Findings/state.ts';
import MembersListing from 'views/Members/index';
import PCFindings from 'views/PCFindings/';
import { ReportList } from 'views/Reports/List.jsx';
import SAST2 from 'views/sast2/index.tsx';
import UserProfile from 'views/UserProfile.jsx';

import { ReleaseNoteList } from './views/Admin/ReleaseNotes/List.jsx';
import GuestsCAInstallationInstructions from './views/CAInstallationInstructions/guests';
import CAInstallationInstructions from './views/CAInstallationInstructions/index';
import NotFound from './views/Errors/NotFound';
import { ScanList } from './views/Scans/List';

function getRoutes() {
  let releaseNoteLabel = getReleaseNotesLabel();

  var routes = [
    {
      path: '/dashboard',
      name: 'Dashboard',
      fullName: 'Dashboard',
      icon: 'tim-icons icon-chart-pie-36',
      // sidebar: false,
      component: Dashboard2,
      layout: '/admin',
    },
    {
      path: '/vulnerabilities',
      name: 'Vulnerabilities',
      fullName: 'Vulnerabilities',
      icon: 'fa fa-bug',
      component: Findings,
      layout: '/admin',
    },
    // {
    //   path: '/qualys/vulnerabilities',
    //   name: 'Vulnerabilities(old)',
    //   fullName: 'Vulnerabilities',
    //   icon: 'fa fa-bug',
    //   layout: '/admin',
    // },
    {
      path: '/qualys/cloud_agents/installation_instructions',
      name: 'Installation Instructions',
      icon: 'CA',
      component: GuestsCAInstallationInstructions,
      sidebar: false,
      layout: '/admin',
    },
    {
      path: '/qualys/cloud_agents/new_installation_instructions',
      name: 'Installation Instructions',
      icon: 'CA',
      component: CAInstallationInstructions,
      sidebar: false,
      layout: '/admin',
    },
    {
      path: `/dashboard#${DashboardType.CA}`,
      name: 'Cloud Agents',
      fullName: 'Cloud Agents',
      icon: sourceTypeConfig[SourceType.CA].iconClass,
      component: Dashboard2,
      layout: '/admin',
    },
    {
      path: `/dashboard#${DashboardType.EP}`,
      name: 'Endpoints',
      fullName: 'Endpoints',
      icon: sourceTypeConfig[SourceType.EP].iconClass,
      component: Dashboard2,
      layout: '/admin',
    },
    {
      path: `/dashboard#${DashboardType.WAS}`,
      name: 'Web Apps',
      fullName: 'Web Apps',
      icon: sourceTypeConfig[SourceType.WAS].iconClass,
      component: Dashboard2,
      layout: '/admin',
    },
    {
      // NOTE: this component is not listed in left menu and excluded
      path: '/sast',
      name: 'SAST_Add_Repos',
      fullName: 'STATIC APP SECURITY TESTING (SAST)',
      icon: sourceTypeConfig[SourceType.SAST].iconClass,
      component: SAST2,
      layout: '/admin',
    },
    {
      path: `/dashboard#${DashboardType.SAST2}`,
      name: 'SAST',
      fullName: 'STATIC APP SECURITY TESTING (SAST)',
      icon: sourceTypeConfig[SourceType.SAST].iconClass,
      component: Dashboard2,
      layout: '/admin',
    },
    {
      path: `/dashboard#${DashboardType.PC}`,
      name: 'Policy Compliance (beta)',
      fullName: 'Policy Compliance',
      icon: 'fas fa-shield-alt',
      component: Dashboard2,
      layout: '/admin',
    },
    {
      path: '/pc-findings',
      name: 'PC Findings (beta)',
      fullName: 'Policy Compliance Findings',
      icon: 'fa fa-clipboard-list',
      component: PCFindings,
      layout: '/admin',
    },
    {
      path: '/cve',
      name: 'CVE Subscriptions',
      fullName: 'CVE Subscriptions',
      icon: 'fa fa-bell',
      component: CVESubscription,
      layout: '/admin',
    },
    // {
    //   path: "/bpr",
    //   name: "CLOUD BPA",
    //   fullName: "Best Practice Assessment (BPA)",
    //   icon: "BP",
    //   component: BPR,
    //   layout: "/admin"
    // },
    {
      path: '/user-profile',
      name: 'User Profile',
      icon: 'tim-icons icon-single-02',
      component: UserProfile,
      sidebar: false,
      layout: '/admin',
    },
    {
      path: '/settings',
      name: 'Settings',
      icon: 'tim-icons icon-single-02',
      component: CompanyConfiguration,
      sidebar: false,
      layout: '/admin',
    },
    {
      path: '/qualys/reports',
      name: 'Reports',
      icon: 'tim-icons icon-bullet-list-67',
      component: ReportList,
      layout: '/admin',
    },
    {
      path: '/members',
      name: 'Members',
      icon: 'fa fa-users',
      component: MembersListing,
      layout: '/admin',
    },
    {
      path: '/product/notes',
      name: releaseNoteLabel,
      icon: 'tim-icons icon-notes',
      component: ReleaseNoteList,
      layout: '/admin',
    },
    {
      path: '/qualys/scans',
      name: 'Scans',
      icon: 'fa fa-qrcode',
      // sidebar: false,
      admin: true,
      component: ScanList,
      layout: '/admin',
    },
    {
      path: '/company/reports',
      name: 'Company Reports',
      icon: 'tim-icons icon-components',
      component: CompanyList,
      admin: true,
      layout: '/admin',
    },
    {
      path: '/qualys/integration',
      name: 'Qualys Authentication',
      icon: 'tim-icons icon-settings',
      component: Qualys,
      admin: true,
      layout: '/admin',
    },
    {
      path: '/404',
      name: '404',
      icon: 'tim-icons icon-chart-pie-36',
      sidebar: false,
      component: NotFound,
      layout: '/admin',
    },
  ];

  return routes;
}

export default getRoutes;
